<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="step0" tag="div">
    <form @submit.prevent="handleSubmit(submit)" class="needs-validation">
      <div class="card">
        <div class="card-body">
          <h4>تعیین وضعیت کمپین</h4>

          <div class="col-12 px-0">
            <validation-select
              :options="options"
              v-model="form.campaign_status_id"
              rules="required"
              validation-field-name="وضعیت"
              option-value-key="id"
              option-text-key="name"
              label="وضعیت"
            >
            </validation-select>
          </div>
          <div class="col-12 px-0">
            <validation-input
              v-model="form.campaign_status_description"
              type="text"
              placeholder="توضیحات"
              rules="max:195"
              validation-field-name="توضیحات"
              label="توضیحات"
            ></validation-input>
          </div>
          <button
            class="btn btn-primary mt-4"
            style="float: left"
            type="submit"
          >
            تعیین وضعیت
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'SetCampaignStatus',
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: {
        campaign_status_id: null,
        campaign_status_description: '',
      },
    }
  },
  mounted() {
    this.form.campaign_status_id = this.campaign.campaign_status
    this.form.campaign_status_description = this.campaign.campaign_status_description
  },
  methods: {
    submit() {
      const data = JSON.parse(JSON.stringify(this.form))
      data.campaign_status_id = data.campaign_status_id.id
      this.$axios
        .put(`campaigns/${this.campaign.id}/set-status`, data)
        .then(() => {
          Swal.fire('موفق!', `وضعیت کمپین با موفقیت تغییر یافت`, 'success')
        })
        .catch((er) => {
          Swal.fire('ناموفق!', er.response.data.error, 'error')
        })
    },
  },
}
</script>
